import { UserContextSchemaData } from '../schema'
import { trackEvent } from './helper'

export const activate_himanow = () => {
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'activate_himanow',
      format: 'jsonschema',
      version: '1-0-0',
    },
  })
}

export const open_himanow = () => {
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'open_himanow',
      format: 'jsonschema',
      version: '1-0-0',
    },
  })
}

export const open_call_list = () => {
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'open_call_list',
      format: 'jsonschema',
      version: '1-0-0',
    },
  })
}

export const join_call = (props: { users: UserContextSchemaData[] }) => {
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'join_call',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })
}

export const leave_call = (props: { users: UserContextSchemaData[] }) => {
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'leave_call',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })
}
